import { TextField } from '@mui/material'
import React from 'react'
import { useRecoilValue } from 'recoil';
import useSavePatient from 'src/Patient/hooks/useSavePatient';
import { errorsFormRegisterState, valuesFormRegisterState } from 'src/Patient/state/atoms';
import InputLabelCustom from 'src/shared/components/forms/InputLabelCustom'

const BirthDateField = () => {
    const { handleChange } = useSavePatient();
    const { fechaNac } = useRecoilValue(valuesFormRegisterState);
    const { fechaNac: errorFechanac } = useRecoilValue(errorsFormRegisterState);

    return (
        <>
            <InputLabelCustom htmlFor="input-fechanac" text="Fecha de nacimiento (*)" />
            <TextField
                id="input-fechanac"
                size="small"
                error={errorFechanac && errorFechanac.length > 0 ? true : false}
                helperText={errorFechanac && errorFechanac.length > 0 ? `${errorFechanac.join("\n")}` : ''}
                style={{ width: '100%' }}
                name="fechaNac"
                type="date"
                value={fechaNac || ""}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{
                    min: "1900-01-01",
                    max: new Date().toISOString().split("T")[0]
                }}
                variant="outlined"
                onChange={handleChange}
                autoComplete="off"
            />
        </>
    )
}

export default BirthDateField